import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchArrivalRatesPerHour from "../../../components/branches/reports/daily/BranchArrivalRatesPerHour";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchArrivalRatesPerHour = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
    descriptionKey="BranchesArrivalRatesPerHour"
    normalizeData={asArray}
    title={`${reportIndex}. Branch Arrival Rates Per Hour`}
  >
    {({ data, renderConfig }) => (
      <BranchArrivalRatesPerHour reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchArrivalRatesPerHour;
